import React from "react";
import popupsyle from "../../style/PopUp.module.css";
import editpopup from "../../style/Pages/EditPage.module.css";
// import { TfiClose } from "react-icons/tfi";
import mainStyle from "../../style/Main.module.css";
import PageInputField from "../../components/ui/input/PagesInput/PagesInput";
import PageInputStyle from "../../components/ui/input/PagesInput/PagesInput.module.css";
import { MultiSelect } from "react-multi-select-component";
// import Button from "../../components/ui/buttons/Button";
import Loader from "../../components/ui/Loader/Loader";
import { useEditEmployee } from "../../hooks/useUserList";
import { useCompanySelect } from "../../hooks/useCommonHooks";
import { getUserDetails } from "../../utils/auth";

const EditUserListPage = ({ show, onClose, data }) => {
  const {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    setFormData, // Add this to the destructured values
  } = useEditEmployee(onClose);

  React.useEffect(() => {
    if (data) {
      setFormData({
        row_id: data.id || "", // Include the ID
        first_name: data.first_name || "",
        last_name: data.last_name || "",
        email: data.email || "",
        phone: data.phone || "",
        address: data.address || "",
        company_id: data.company_id || [],
      });
    }
  }, [data, setFormData]);

  const companyList = useCompanySelect();
  const user = getUserDetails();

  const companyOptions = companyList.map((company) => ({
    label: company.label, // Replace 'name' with your actual company name property
    value: company.value, // Replace 'id' with your actual company ID property
  }));

  // Get current selected values in MultiSelect format
  const selectedCompanies = formData.company_id
    ? companyList
        .filter((c) => formData.company_id.includes(c.value))
        .map((c) => ({ label: c.label, value: c.value }))
    : [];

  if (!show) return null;
  const handleClose = () => {
    onClose();
  };

  return (
    <div className={popupsyle.popupBackground}>
      <div className={editpopup.editPopupContainer}>
        <div className={popupsyle.PopupContainer}>
          <div className={popupsyle.popupHeader}>
            <h3>Edit User</h3>
            {/* <button onClick={onClose} className={popupsyle.closeButton}>
            ×
          </button> */}

            {/* <TfiClose
              onClick={onClose}
              size={20}
              className={popupsyle.closePopup}
            /> */}
            {/* <div className={popupsyle.buttonClose}>x</div> */}
          </div>

          <div className={popupsyle.popupContent}>
            <div className={mainStyle.mainContentFormSplit}>
              <PageInputField
                label="First Name"
                name="first_name"
                placeholder="e.g., John"
                required
                value={formData?.first_name || ""}
                onChange={handleInputChange}
                error={error?.first_name}
              />

              <PageInputField
                label="Last Name(Optional)"
                name="last_name"
                placeholder="e.g., Doe"
                // required
                value={formData?.last_name || ""}
                onChange={handleInputChange}
                error={error?.last_name}
              />
            </div>
            <div className={mainStyle.mainContentFormSplit}>
              <PageInputField
                label="Email"
                name="email"
                placeholder="e.g., john.doe@example.com"
                required
                value={formData?.email || ""}
                onChange={handleInputChange}
                error={error?.email}
              />
              <PageInputField
                label="Phone"
                name="phone"
                placeholder="e.g., 876543210"
                required
                value={formData?.phone || ""}
                onChange={handleInputChange}
                error={error?.phone}
              />
            </div>

            <div className={mainStyle.mainInputDiv}>
              <label htmlFor="text" className={PageInputStyle.label}>
                Address<span className={mainStyle.mantitory}>*</span>
              </label>
              <textarea
                className={PageInputStyle.input}
                name="address"
                placeholder="e.g.,  House No, Locality, Landmark, City, PIN"
                value={formData?.address || ""}
                onChange={handleInputChange}
              />
              {error?.address && (
                <span className={mainStyle.errorMsg}>{error?.address}</span>
              )}
            </div>

            {user.role === "admin" && (
              <div className={mainStyle.mainInputDiv}>
                <label htmlFor="text" className={PageInputStyle.label}>
                  Company<span className={mainStyle.mantitory}>*</span>
                </label>
                <MultiSelect
                  key={formData?.company_id.length} // 👈 Forces remount when cleared
                  options={companyOptions}
                  value={selectedCompanies}
                  onChange={(selected) =>
                    handleInputChange({
                      target: {
                        name: "company_id",
                        value: selected.map((option) => option.value),
                      },
                    })
                  }
                  labelledBy="Select Companies"
                  className={mainStyle.mutiSelectDropDown}
                  overrideStrings={{
                    allItemsAreSelected: "All companies selected",
                    selectSomeItems: "Select Companies",
                  }}
                />
                {error?.company_id && (
                  <span className={mainStyle.errorMsg}>
                    {error?.company_id}
                  </span>
                )}
              </div>
            )}

            {/* 
                            <div className={mainStyle.mainContentFormSplit}>
                           

                       
                                <div className={mainStyle.mainButtonDiv} style={{ width: "100%" }}>
                                    <Button onClick={handleSubmit}> {loading ? <Loader/> : "Invite"}</Button>
                                </div>
                            </div> */}

            <br />
          </div>

          <div className={popupsyle.popupButtonDiv}>
            {/* <Button onClick={handleSubmit}>
              {" "}
              {loading ? <Loader /> : "Update"}
            </Button> */}
            <div className={popupsyle.actionButtons}>
              <button className={popupsyle.cancelButton} onClick={handleClose}>
                Cancel
              </button>
              <button
                className={popupsyle.updateButton}
                onClick={handleSubmit}
                // disabled={loader}
              >
                {loading ? <Loader /> : "Update"}
                {/* {loader ? (
                  <div className={styles.spinner}></div>
                ) : (
                  "Delete Logs"
                )} */}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserListPage;
